import React, { useEffect, useState } from 'react'
import { IDataDisplayerItem, IDataDisplayerItemField } from './DataDisplayer'
import DataDisplayerItemField, { BaseDataDisplayerItemField } from './DataDisplayerItemField'
import { IconButton } from '@mui/material'
import GenerateIcon from '../GenerateIcon'
import DisplayerItemOptions from './DisplayerItemOptions'

interface IProps extends IDataDisplayerItem{
    handleDeleteItem: (id: number) => void,
}   

export default function DataDisplayerSubItem(props: IProps) {

    const { id, fields, customActionOptions, handleDeleteItem, rawItem } = props

    const [showOptions, setShowOptions] = useState<boolean>(false)

    const baseContainerClassName: string = "data-displayer-single-sub-item-box"
    const [containerClassName, setContainerClassName] = useState<string>(baseContainerClassName)

    return(
        <div className={containerClassName}>
            <div className="content-of-data-displayer-single-sub-item-box">

                {fields.map((field: IDataDisplayerItemField, index: number) => <DataDisplayerItemField rawItem={rawItem} showLabel hideColumns={[]} {...field} key={index} />)}

                <BaseDataDisplayerItemField rawItem={rawItem} type="option-buttons" isActionButtons={true} maxWidth={0} minWidth={0}>

                    <IconButton onClick={() => setShowOptions(true)}>
                        <GenerateIcon icon="options" />
                    </IconButton>

                    <DisplayerItemOptions itemActionOptions={customActionOptions ? customActionOptions : []} item={props} isShown={showOptions} handleDeleteItem={handleDeleteItem} hideModal={() => setShowOptions(false)} />
                </BaseDataDisplayerItemField>

            </div>
        </div>
    )
}